import React from "react";

function Terms()
{
    return (
        <div>
            <section id="terms" className="py-12 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="max-w-3xl mx-auto">
                        <h1 className="text-4xl font-serif font-bold text-custom-green mb-6 text-center">
                            Όροι και Προϋποθέσεις
                        </h1>

                        {/* Τρόποι πληρωμής */}
                        <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-3">Τρόποι πληρωμής</h2>
                        <p className="text-gray-700 leading-7">
                            Στο ηλεκτρονικό μας κατάστημα μπορείτε να πληρώσετε με τους παρακάτω τρόπους:
                        </p>

                        <ol className="list-decimal pl-6 mt-4 space-y-4 text-gray-700 leading-7">
                            <li>
                                <span className="font-semibold">Με χρεωστική/πιστωτική κάρτα</span>
                                <div className="mt-1">
                                    Αποδεκτές κάρτες: οποιαδήποτε πιστωτική (credit), χρεωστική (debit) των διεθνών σχημάτων
                                    Visa, Mastercard, Maestro.
                                </div>
                            </li>

                            <li>
                                <span className="font-semibold">Κατάθεση σε τραπεζικό λογαριασμό</span>
                                <div className="mt-2">
                                    Η εξόφληση της παραγγελίας σας με κατάθεση, μπορεί να πραγματοποιηθεί στον παρακάτω
                                    τραπεζικό λογαριασμό:
                                </div>

                                <div className="mt-3 rounded-xl border border-gray-200 bg-gray-50 p-4 text-sm leading-6">
                                    <div><span className="font-semibold">Τράπεζα:</span> Eurobank</div>
                                    <div><span className="font-semibold">Αριθμός λογαριασμού:</span> 0026.0378.51.0200738931</div>
                                    <div><span className="font-semibold">Iban:</span> GR4302603780000510200738931</div>
                                    <div><span className="font-semibold">Δικαιούχος:</span> ΡΟΘΕΡΑΣ Ι.Κ.Ε.</div>
                                    <div><span className="font-semibold">Swift:</span> ERBKGRAA</div>
                                </div>

                                <p className="mt-3 text-gray-700 leading-7">
                                    <span className="font-semibold">Σημείωση:</span> Τα διατραπεζικά έξοδα του εμβάσματος από
                                    άλλη τράπεζα επιβαρύνουν τον πελάτη και όχι την εταιρεία.
                                </p>

                                <p className="mt-3 text-gray-700 leading-7">
                                    Μετά την πληρωμή σας θα χρειαστεί να μας αποστείλετε το καταθετήριο της τράπεζας μέσω e-mail
                                    στη διεύθυνση <span className="font-semibold">rotheras.ike@gmail.com</span> όπου θα χρειαστεί
                                    να αναγράψετε στην αιτιολογία τον αριθμό της παραγγελίας σας.
                                </p>

                                <p className="mt-3 text-gray-700 leading-7">
                                    Η κατάθεση πρέπει να γίνει μέσα σε δυο (2) εργάσιμες ημέρες από την ημέρα της παραγγελίας.
                                    Σε αντίθετη περίπτωση η παραγγελία σας ακυρώνεται. Ο παραπάνω όρος δεν ισχύει εφόσον έχει
                                    προηγηθεί συνεννόηση μαζί μας.
                                </p>

                                <p className="mt-3 text-gray-700 leading-7">
                                    <span className="font-semibold">Αριθμός ΓΕΜΗ:</span> 185894301000
                                </p>
                            </li>
                        </ol>

                        {/* Πολιτική Επιστροφών */}
                        <h2 className="text-2xl font-semibold text-gray-900 mt-12 mb-3">Πολιτική Επιστροφών</h2>

                        <p className="text-gray-700 leading-7">
                            Η παραγγελία σας δεν ανταποκρίνεται στις προσδοκίες σας; Θέλετε να προχωρήσετε σε επιστροφή;
                            Τότε ακολουθήστε την παρακάτω διαδικασία:
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Εντός 15 (δεκαπέντε) ημερών από την ημερομηνία παραλαβής της παραγγελίας σας έχετε το δικαίωμα
                            να επιστρέψετε το προϊόν που παραλάβατε με απαραίτητη προϋπόθεση το προϊόν να είναι ακέραιο,
                            να μην έχει χρησιμοποιηθεί και να συνοδεύεται από την πρωτότυπη απόδειξη αγοράς.
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Για να επιστρέψετε ένα προϊόν πρέπει να επικοινωνήσετε μαζί μας μέσω e-mail στο{" "}
                            <span className="font-semibold">rotheras.ike@gmail.com</span> ή τηλεφωνικά στο{" "}
                            <span className="font-semibold">(+30) 6976906868</span>.
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Εφόσον η επιστροφή οφείλεται σε υπαιτιότητα της επιχείρησης (αποστολή λανθασμένου ή
                            ελαττωματικού προϊόντος), η παραλαβή από το χώρο σας γίνεται μετά από συνεννόηση με εμάς
                            και το κόστος της αποστολής, επιβαρύνει εμάς.
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Σε κάθε άλλη περίπτωση που επιθυμείτε να επιστρέψετε ή να αλλάξετε κάποιο προϊόν, μπορείτε να
                            το κάνετε χρησιμοποιώντας τρόπο μεταφοράς της επιλογής σας, αναλαμβάνοντας εξ' ολοκλήρου
                            το κόστος και την ευθύνη της μεταφοράς.
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Πριν από κάθε επιστροφή θα πρέπει να επικοινωνήσετε μαζί μας μέσω e-mail στο{" "}
                            <span className="font-semibold">rotheras.ike@gmail.com</span> ή τηλεφωνικά στο{" "}
                            <span className="font-semibold">(+30) 6976906868</span>.
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Όσον αφορά την επιστροφή χρημάτων, μπορείτε να πραγματοποιήσετε εκ νέου παραγγελία κάποιου
                            άλλου προϊόντος ανάλογης ή και διαφορετικής αξίας και σε περίπτωση διαφορετικής αξίας ανώτερης
                            του επιστρεφόμενου είδους γίνεται πληρωμή η διαφορά του ποσού. Το χρηματικό ποσό πιστώνεται σε
                            λογαριασμό που θα μας υποδείξετε.
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Εάν για τον οποιονδήποτε λόγο θέλετε να ακυρώσετε την παραγγελία σας, επικοινωνήστε μαζί μας
                            εντός της ίδιας ημέρας στο <span className="font-semibold">6976906868</span> ή ηλεκτρονικά στο{" "}
                            <span className="font-semibold">rotheras.ike@gmail.com</span> γνωστοποιώντας μας τον αριθμό της
                            παραγγελίας.
                        </p>

                        {/* Τρόποι Αποστολής */}
                        <h2 className="text-2xl font-semibold text-gray-900 mt-12 mb-3">Τρόποι Αποστολής</h2>

                        <p className="text-gray-700 leading-7">
                            Η αποστολή των προϊόντων μας πραγματοποιείται με:
                        </p>
                        <ul className="list-disc pl-6 mt-2 text-gray-700 leading-7">
                            <li>Συνεργαζόμενη εταιρεία courier ( Elta Courier )</li>
                        </ul>

                        <p className="mt-3 text-gray-700 leading-7">
                            Ο χρόνος παράδοσης μπορεί να διαρκέσει 2-4 εργάσιμες μέρες και εξαρτάται από τον προορισμό
                            (απόσταση, δυσκολία σε πρόσβαση, δυσμενείς συνθήκες).
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Η χρέωση της μεταφοράς με την courier είναι 3 ευρώ. Για παραγγελίες από 80 ευρώ και άνω δεν
                            χρεώνονται τα έξοδα αποστολής.
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Τα ογκώδη αντικείμενα (π.χ καλαθούνα/λίκνο, αλλαξιέρα, επιδαπέδια καλάθια, επιδαπέδια βάζα,
                            pet basket κτλ) αποστέλλονται με μεταφορική εταιρία (παράδοση κατ’οίκον) ή με τα Elta Courier
                            ( μέσω ΕΛΤΑ κατ'οίκον ). Ο χρόνος παράδοσης μπορεί να διαρκέσει 5-7 εργάσιμες μέρες και εξαρτάται
                            από τον προορισμό (απόσταση, δυσκολία σε πρόσβαση, δυσμενείς συνθήκες).
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Επειδή κάθε δημιουργία μας φτιάχνεται στο χέρι με φροντίδα, χρειαζόμαστε κάποιο χρόνο προετοιμασίας
                            πριν την αποστολή. Ο χρόνος κατασκευής διαφέρει ανά προϊόν και θα τον βρείτε αναλυτικά στην
                            περιγραφή του.
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Έχετε τη δυνατότητα να ακυρώσετε την παραγγελία σας με επικοινωνία είτε μέσω email στο{" "}
                            <span className="font-semibold">rotheras.ike@gmail.com</span> αναγράφοντας{" "}
                            <span className="font-semibold">ΑΚΥΡΩΣΗ ΠΑΡΑΓΓΕΛΙΑΣ</span> και τον αριθμό της παραγγελίας σας,
                            είτε μέσω τηλέφωνου στο <span className="font-semibold">6976906868</span>.
                        </p>

                        {/* Πολιτική Απορρήτου - ΟΛΟΚΛΗΡΗ */}
                        <h2 className="text-2xl font-semibold text-gray-900 mt-12 mb-3">Πολιτική Απορρήτου</h2>

                        <h3 className="text-lg font-semibold text-gray-900 mt-6">α). Εισαγωγή</h3>
                        <ol className="list-decimal pl-6 mt-2 space-y-2 text-gray-700 leading-7">
                            <li>
                                Το απόρρητο των επισκεπτών του ιστοτόπου μας, είναι πολύ σημαντικό για εμάς και είμαστε
                                αφοσιωμένοι στην προστασία του. Η πολιτική μας εξηγεί πως θα χρησιμοποιήσουμε τις προσωπικές
                                σας πληροφορίες.
                            </li>
                            <li>
                                Η συναίνεση σας στη χρήση των cookies σε συμφωνία με τους όρους της πολιτικής μας κατά την
                                πρώτη σας επίσκεψη στον ιστότοπο, μας επιτρέπει την χρήση cookies κάθε φορά που επισκέπτεστε
                                τον ιστότοπο μας.
                            </li>
                            <li>
                                Οι κάτωθι όροι και προϋποθέσεις θα εφαρμόζονται για τη χρήση του ηλεκτρονικού καταστήματος
                                www.rotheras.gr. Κάθε χρήστης που εισέρχεται και συναλλάσσεται ή κάνει χρήση των υπηρεσιών
                                του ηλεκτρονικού καταστήματος θεωρείται ότι συναινεί και αποδέχεται ανεπιφύλακτα τους
                                κατωτέρω όρους που εδώ διατυπώνονται, χωρίς καμία εξαίρεση. Κάθε επισκέπτης του ηλεκτρονικού
                                καταστήματος οφείλει να διαβάσει προσεκτικά τους όρους χρήσης και σε περίπτωση διαφωνίας να
                                μην κάνει χρήση αυτού. Η εταιρεία διατηρεί το δικαίωμα να τροποποιεί ή να αναθεωρεί ελεύθερα
                                τους όρους χρήσης και τις προϋποθέσεις του ηλεκτρονικού καταστήματος οποτεδήποτε κρίνεται
                                αναγκαίο.
                            </li>
                        </ol>

                        <h3 className="text-lg font-semibold text-gray-900 mt-8">β). Συλλογή προσωπικών πληροφοριών</h3>
                        <p className="text-gray-700 leading-7 mt-2">
                            Οι παρακάτω τύποι προσωπικών πληροφοριών μπορούν να συλλεγούν, να αποθηκευτούν και να
                            χρησιμοποιηθούν:
                        </p>
                        <ol className="list-decimal pl-6 mt-2 space-y-2 text-gray-700 leading-7">
                            <li>Πληροφορίες σχετικές με τον υπολογιστή σας μεταξύ των οποίων η διεύθυνση IP σας, η γεωγραφική σας τοποθεσία ο τύπος και η έκδοση του περιηγητή σας και το λειτουργικό σας σύστημα.</li>
                            <li>Πληροφορίες σχετικά με τις επισκέψεις σας και τη χρήση του ιστοτόπου περιλαμβάνοντας την εξωτερική πηγή, τη διάρκεια της επίσκεψης, της προβολές σελίδων και τη διαδρομή πλοήγησης στον ιστότοπο.</li>
                            <li>Πληροφορίες όπως η διεύθυνση email σας, την οποία εισάγετε κατά την εγγραφή στον ιστότοπο.</li>
                            <li>Πληροφορίες, όπως το όνομα και το email, τις οποίες εισάγετε κατά την ρύθμιση των συνδρομών σας και για την αποστολή των emails και/η των ενημερωτικών δελτίων.</li>
                            <li>Πληροφορίες που εισάγετε κατά τη χρήση υπηρεσιών στον ιστότοπο μας.</li>
                            <li>Πληροφορίες που προκύπτουν κατά τη χρήση του ιστοτόπου, όπως πότε, πόσο συχνά και κάτω από ποιες συνθήκες το χρησιμοποιείτε.</li>
                            <li>Πληροφορίες σχετικές με τις αγορές σας, τις υπηρεσίες που χρησιμοποιείτε και τις συναλλαγές που κάνετε στον ιστότοπο, οι οποίες περιλαμβάνουν το όνομα, τη διεύθυνση, τον τηλεφωνικά σας αριθμό, τη διεύθυνση του email σας και τις πληροφορίες της πιστωτικής σας κάρτας.</li>
                            <li>Πληροφορίες που περιέχονται σε οποιαδήποτε επικοινωνία σας με εμάς μέσω email ή μέσω του ιστοτόπου, περιλαμβάνοντας το περιεχόμενο επικοινωνίας και τα μεταδεδομένα (metadata).</li>
                            <li>Οποιαδήποτε άλλη προσωπική πληροφορία μας στέλνετε.</li>
                        </ol>

                        <p className="mt-3 text-gray-700 leading-7">
                            Προτού αποκαλύψετε οποιαδήποτε προσωπικές πληροφορίες κάποιου τρίτου ατόμου, θα πρέπει να
                            έχετε τη συγκατάθεση αυτού του ατόμου σχετικά με την κοινοποίηση και την επεξεργασία των
                            προσωπικών πληροφοριών του, σύμφωνα με την παρούσα πολιτική.
                        </p>

                        <h3 className="text-lg font-semibold text-gray-900 mt-8">γ). Χρήση των προσωπικών σας πληροφοριών</h3>
                        <p className="text-gray-700 leading-7 mt-2">
                            Οι προσωπικές πληροφορίες που υποβάλλονται σε εμάς χρησιμοποιούνται για τους
                            σκοπούς που ορίζονται από αυτή την πολιτική στις σχετικές σελίδες του ιστοτόπου.
                        </p>
                        <p className="text-gray-700 leading-7 mt-2">
                            Μπορούμε να χρησιμοποιήσουμε τις προσωπικές πληροφορίες για τους παρακάτω σκοπούς:
                        </p>
                        <ol className="list-decimal pl-6 mt-2 space-y-2 text-gray-700 leading-7">
                            <li>Διαχείριση του ιστοτόπου και της επιχείρησης μας</li>
                            <li>Προσωποποιημένη διαμόρφωση του ιστοτόπου για εσάς</li>
                            <li>Ενεργοποίηση της χρήσης των διαθέσιμων υπηρεσιών σας στον ιστότοπο μας</li>
                            <li>Αποστολή των αγαθών που αγοράζετε μέσω του ιστοτόπου μας</li>
                            <li>Παροχή υπηρεσιών που αγοράζετε μέσω του ιστοτόπου μας</li>
                            <li>Αποστολή κινήσεων, τιμολογίων και υπενθυμίσεων πληρωμής σε εσάς, καθώς και συλλογή πληρωμών από εσάς</li>
                            <li>Αποστολή μη διαφημιστικών επικοινωνιών</li>
                            <li>Αποστολή ειδοποιήσεων μέσω email σχετικά με τα αιτήματά σας</li>
                            <li>Αποστολή του ενημερωτικού δελτίου μας μέσω email αν το έχετε ζητήσει (μπορείτε να μας ενημερώσετε ανά πάσα στιγμή αν πλέον δεν επιθυμείτε το ενημερωτικό δελτίο)</li>
                            <li>Αποστολή διαφημιστικών επικοινωνιών, σχετικών με την επιχείρηση σας ή τις επιχειρήσεις συγκεκριμένων τρίτων μερών οι οποίες πιστεύουμε ότι μπορεί να σας ενδιαφέρουν, μέσω κοινοποιήσεων ή, αν έχετε συμφωνήσει σε αυτό, μέσω by email ή παρόμοιας τεχνολογίας (μπορείτε να μας ενημερώσετε ανά πάσα στιγμή αν πλέον δεν επιθυμείτε διαφημιστικές επικοινωνίες)</li>
                            <li>Παροχή στατιστικών δεδομένων των χρηστών μας σε τρίτα μέρη (τα οποία δεν θα είναι σε θέση να ταυτοποιήσουν κανένα χρήστη από αυτές τις πληροφορίες)</li>
                            <li>Διαχείριση αιτημάτων και παραπόνων που υποβάλατε οι ίδιοι ή σχετίζονται με τον ιστότοπο σας</li>
                            <li>Διατήρηση της ασφάλειας του ιστοτόπου και πρόληψη κατά οποιασδήποτε απάτης</li>
                            <li>Επιβεβαίωση της συμμόρφωσης με τους όρους και προϋποθέσεις παροχής του ιστοτόπου μας (περιλαμβάνοντας και τη επιτήρηση προσωπικών μηνυμάτων που διακινούνται μέσω της ιδιωτικής διαδικτυακής υπηρεσίας μηνυμάτων μας) και</li>
                            <li>Άλλες χρήσεις.</li>
                        </ol>

                        <p className="mt-3 text-gray-700 leading-7">
                            Αν υποβάλλετε προσωπικές πληροφορίες προς δημοσίευση στον ιστότοπο μας, θα δημοσιεύσουμε ή θα
                            χρησιμοποιήσουμε αυτές τις πληροφορίες σε συμφωνία με την αδειοδότηση σας.
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Οι ρυθμίσεις απορρήτου σας μπορούν να χρησιμοποιηθούν για να περιορίσουν τη δημοσίευση των
                            πληροφοριών σας στον ιστότοπο μας και μπορούν να διαμορφωθούν χρησιμοποιώντας τον έλεγχο
                            απορρήτου στον ιστότοπο.
                        </p>

                        <p className="mt-3 text-gray-700 leading-7">
                            Δεν θα διοχετεύσουμε τις προσωπικές σας πληροφορίες χωρίς τη συναίνεση σας σε κανένα τρίτο μέρος
                            ή σε οποιαδήποτε εμπορικό τμήμα τρίτου μέρους.
                        </p>

                        {/* δ). Κοινοποίηση προσωπικών πληροφοριών */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">δ). Κοινοποίηση προσωπικών πληροφοριών</h3>

                        <p className="text-gray-700 leading-7 mt-2">
                            Μπορούμε να κοινοποιήσουμε τις προσωπικές σας πληροφορίες σε οποιονδήποτε από τους υπαλλήλους μας,
                            τα στελέχη, τους ασφαλιστές ή τους επαγγελματικούς συμβούλους, τους εκπροσώπους, τους προμηθευτές
                            ή τους υπεργολάβους μας όπως απαιτείται για τους σκοπούς που αναφέρει η παρούσα πολιτική.
                        </p>

                        <p className="text-gray-700 leading-7 mt-2">
                            Μπορούμε να κοινοποιήσουμε τις προσωπικές σας πληροφορίες σε οποιονδήποτε από
                            τους υπαλλήλους μας, τα στελέχη, τους ασφαλιστές, ή τους επαγγελματικούς
                            συμβούλους, τους εκπροσώπους τους προμηθευτές ή τους υπεργολάβους μας όπως
                            απαιτείται για τους σκοπούς που αναφέρει η παρούσα πολιτική.
                        </p>

                        <p className="text-gray-700 leading-7 mt-2">
                            Μπορούμε να κοινοποιήσουμε τις προσωπικές σας πληροφορίες σε οποιοδήποτε μέλος
                            του ομίλου εταιρειών μας (αυτό σημαίνει τις θυγατρικές μας εταιρείες, την ελέγχου
                            εταιρεία του χαρτοφυλακίου μας και τις θυγατρικές της) όπως απαιτείται για τους
                            σκοπούς που αναφέρει η παρούσα πολιτική.
                        </p>

                        <p className="text-gray-700 leading-7 mt-2">
                            Μπορούμε να κοινοποιήσουμε τις προσωπικές μας πληροφορίες:
                            1. στο μέτρο που απαιτείται βάσει νόμου
                            2. σε σχέση με οποιαδήποτε τρέχουσα ή μελλοντική νομική διαδικασία
                            3. με σκοπό την εδραίωση, άσκηση ή υπεράσπιση των νομίμων δικαιωμάτων μας
                            (μεταξύ των οποίων η παροχή πληροφοριών σε τρίτους με σκοπό την πρόληψη
                            απάτης και την ελάττωση του πιστωτικού κινδύνου)
                            4. στον αγοραστή (ή πιθανού αγοραστή) οποιουδήποτε αγαθού της επιχείρισης το
                            οποίο πουλάμε (ή σκεφτόμαστε να πουλήσουμε) και

                            5. σε οποιονδήποτε βάσιμα πιστεύουμε ότι μπορεί να ανήκει στην δικαστική η
                            οποιοδήποτε άλλη αρμόδια αρχή σχετικά με την κοινοποίηση πληροφοριών στην
                            περίπτωση που θεωρούμε ότι η αντίστοιχη αρχή θα απαιτήσει την κοινοποίηση
                            των συγκεκριμένων προσωπικών πληροφοριών.
                            Επίσης όπως αναφέρεται στην παρούσα πολιτική, δεν θα παρέχουμε τις προσωπικές
                            σας πληροφορίες σε τρίτα μέρα.
                        </p>

                        <p className="text-gray-700 leading-7 mt-2">
                            Δεν θα παρέχουμε τις προσωπικές σας πληροφορίες σε τρίτα μέρη εκτός από τις περιπτώσεις που
                            αναφέρονται στην παρούσα πολιτική.
                        </p>

                        {/* ε). Διεθνείς μεταφορές δεδομένων */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">ε). Διεθνείς μεταφορές δεδομένων</h3>

                        <ol className="list-decimal pl-6 mt-2 space-y-2 text-gray-700 leading-7">
                            <li>
                                Οι πληροφορίες που συλλέγουμε μπορεί να αποθηκευτούν να επεξεργαστούν και
                                να μετακινηθούν μεταξύ οποιωνδήποτε χωρών στις οποίες λειτουργούμε έτσι
                                ώστε να μπορούμε να χρησιμοποιήσουμε σύμφωνα με την παρούσα πολιτική.
                            </li>
                            <li>
                                Οι πληροφορίες που συλλέγουμε μπορούν να μεταφερθούν στις ακόλουθες
                                χώρες που δεν διαθέτουν αντίστοιχη νομοθεσία προστασίας προσωπικών
                                δεδομένων με αυτή που εφαρμόζεται στην Ευρωπαϊκή Οικονομική Περιοχή: οι
                                ΗΠΑ, η Ρωσία η Ιαπωνία η Κίνα και η Ινδία.
                            </li>
                            <li>
                                Οι προσωπικές πληροφορίες που δημοσιεύετε στον ιστότοπο μας ή υποβάλλετε
                                προς δημοσίευση στον ιστότοπο μας, δύνανται είναι διαθέσιμες μέσω διαδικτύου
                                σε όλο τον κόσμο. Δεν μπορούμε να αποτρέψουμε τη χρήση ή τη λανθασμένη
                                χρήση τέτοιων πληροφοριών από τρίτους.
                            </li>
                            <li>
                                Συμφωνείτε ρητά στη μεταφορά των προσωρινών δεδομένων η οποία
                                περιγράφεται στην ενότητα προσωρινών δεδομένων.
                            </li>
                        </ol>

                        {/* ζ). Διατήρηση προσωπικών δεδομένων */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">ζ). Διατήρηση προσωπικών δεδομένων</h3>

                        <ol className="list-decimal pl-6 mt-2 space-y-2 text-gray-700 leading-7">
                            <li>
                                Η Ενότητα ορίζει την διαδικασία και την πολιτική διατήρησης προσωπικών
                                δεδομένων, που έχει σχεδιαστεί για να διασφαλίζει τη συμμόρφωση με τις
                                νομικές μας υποχρεώσεις σχετικά με τη διατήρηση και τη διαγραφή των
                                προσωπικών δεδομένων.
                            </li>
                            <li>
                                Προσωπικά δεδομένα που επεξεργαζόμαστε για οποιοδήποτε σκοπό δεν θα
                                διατηρούνται για περισσότερο από όσο διάστημα είναι απαραίτητο για αυτό το
                                σκοπό.
                            </li>
                            <li>
                                Τα προσωπικά δεδομένα διαγράφονται όταν δεν είναι πλέον απαραίτητα για τους
                                σκοπούς επεξεργασίας, συνήθως μετά τη λήξη της συμβατικής σχέσης, τη
                                διεκπεραίωση αιτημάτων ή τη λήξη νομικών υποχρεώσεων. Κατηγορίες όπως
                                δεδομένα ταυτοποίησης, οικονομικά στοιχεία και cookies διαγράφονται σύμφωνα
                                με τις προθεσμίες που ορίζει ο GDPR.
                                1.1.προσωπικά δεδομένα τύπου θα διαγράφονται σε διάστημα δύο ετών.

                                4. Παρά τις υπόλοιπες διατάξεις που προβλέπει η Ενότητα G, θα διατηρήσουμε
                                έγγραφα (μεταξύ των οποίων και ηλεκτρονικά έγγραφα) που περιέχουν
                                προσωπικά δεδομένα
                                5. 1.1.1.στο βαθμό που απαιτείται από το νόμο.

                                1. αν θεωρούμε ότι τα έγγραφα μπορεί να σχετίζονται με
                                οποιαδήποτε νομική διαδικασία σε ισχύ και
                                2. με σκοπό την εδραίωση, άσκηση ή υπεράσπιση των
                                νομίμων δικαιωμάτων μας (μεταξύ των οποίων η παροχή
                                πληροφοριών σε τρίτους με σκοπό την πρόληψη απάτης και
                                την ελάττωση του πιστωτικού κινδύνου)
                            </li>
                        </ol>

                        {/* η). Ασφάλεια προσωπικών δεδομένων */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">η). Ασφάλεια προσωπικών δεδομένων</h3>

                        <ol className="list-decimal pl-6 mt-2 space-y-2 text-gray-700 leading-7">
                            <li>
                                Θα λάβουμε τις απαιτούμενες προφυλάξεις σε τεχνικό και οργανωτικό επίπεδο
                                για να αποτρέψουμε την απώλεια, την κακή χρήση η την αλλοίωση των
                                προσωπικών σας δεδομένων.
                            </li>
                            <li>
                                Θα αποθηκεύσουμε όλα τα προσωπικά δεδομένα που παρέχετε στους ασφαλείς
                                (προστατευμένους με κωδικό- και τείχος προστασίας) διακομιστές.
                            </li>
                            <li>
                                Όλες οι ηλεκτρονικές χρηματικές συναλλαγές που διενεργούνται στον ιστότοπο
                                μας προστατεύονται από την τεχνολογία κρυπτογράφησης μας.
                            </li>
                            <li>
                                Αποδέχεστε ότι η μετάδοση πληροφοριών στο διαδίκτυο είναι εγγενώς μη
                                ασφαλής και δεν μπορούμε να εγγυηθούμε την ασφάλεια των δεδομένων που
                                διακινούνται μέσω διαδικτύου.
                            </li>
                        </ol>

                        {/* θ). Τροποποιήσεις */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">θ). Τροποποιήσεις</h3>

                        <p className="text-gray-700 leading-7 mt-2">
                            Μπορεί να ενημερώνουμε την πολιτικής μας κατά καιρούς δημοσιεύοντας μία νέα
                            έκδοση στον ιστότοπο μας κατά καιρούς. Θα πρέπει περιστασιακά να ελέγχετε τη σελίδα
                            ώστε να σιγουρευτείτε ότι κατανοείτε οποιαδήποτε αλλαγή στην πολιτική μας. Μπορεί να
                            σας ενημερώσουμε για αλλαγές στην πολιτική μας μέσω email ή μέσω ιδιωτικού
                            συστήματος ανταλλαγής μηνυμάτων στον ιστότοπο μας.
                        </p>

                        {/* ι). Τα δικαιώματά σας */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">ι). Τα δικαιώματά σας</h3>

                        <p className="text-gray-700 leading-7 mt-2">
                            Μπορείτε να ζητήσετε οποιαδήποτε προσωπική πληροφορία σας διατηρούμε, κατόπιν παροχής επαρκών
                            στοιχείων ταυτοποίησης.
                        </p>

                        <p className="text-gray-700 leading-7 mt-2">
                            Μπορείτε επίσης να ζητήσετε ανά πάσα στιγμή να μην επεξεργαζόμαστε τα προσωπικά σας δεδομένα
                            για διαφημιστικούς σκοπούς.
                        </p>
                        <p className="text-gray-700 leading-7 mt-2">
                            Στην πράξη, συνήθως είτε θα αποδέχεστε ρητά εκ των προτέρων την χρήση των
                            προσωπικών σας πληροφοριών για διαφημιστικούς σκοπούς, είτε θα σας παρέχουμε τη
                            δυνατότητα να εξαιρέσετε τις πληροφορίες σας από τη χρήση για διαφημιστικούς
                            σκοπούς.
                        </p>

                        {/* κ). Τρίτοι ιστότοποι */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">κ). Τρίτοι ιστότοποι</h3>

                        <p className="text-gray-700 leading-7 mt-2">
                            Ο ιστότοπος μας περιλαμβάνει υπερσυνδέσμους προς τρίτους ιστότοπους. Δεν φέρουμε ευθύνη για τις
                            πολιτικές απορρήτου ή τις πρακτικές τους.
                        </p>

                        {/* λ). Ενημέρωση πληροφοριών */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">λ). Ενημέρωση πληροφοριών</h3>

                        <p className="text-gray-700 leading-7 mt-2">
                            Παρακαλούμε ενημερώστε μας εάν οι προσωπικές πληροφορίες που διατηρούμε για εσάς χρειάζονται
                            διόρθωση ή ενημέρωση στο email <span className="font-semibold">rotheras.ike@gmail.com</span>.
                        </p>

                        {/* μ). Cookies */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">μ). Cookies</h3>

                        <p className="text-gray-700 leading-7 mt-2">
                            Ο ιστότοπος μας χρησιμοποιεί cookies. Ένα cookie είναι ένα αρχείο που περιέχει ένα
                            αναγνωριστικό (μία σειρά γραμμάτων και αριθμών) το οποίο αποστέλλεται μέσω ενός
                            διακομιστή και αποθηκεύεται στον περιηγητή. Το αναγνωριστικό αποστέλλεται πίσω
                            στο διακομιστή κάθε φορά που ο περιηγητής ζητά μία σελίδα.
                        </p>

                        <p className="text-gray-700 leading-7 mt-2">
                            Τα cookies μπορεί να είναι είτε <span className="font-semibold">μόνιμα</span> είτε cookies
                            <span className="font-semibold"> σύνδεσης</span>. Ένα μόνιμο cookie αποθηκεύεται στον
                            περιηγητή και παραμένει σε ισχύ μέχρι την ημερομηνία λήξης του, εκτός αν διαγραφεί
                            νωρίτερα από το χρήστη. Ένα cookie σύνδεσης λήγει με το τέλος της σύνδεσης του
                            χρήστη, όταν κλείσει ο περιηγητής.
                        </p>

                        <p className="text-gray-700 leading-7 mt-2">
                            Τα cookies συνήθως δεν περιέχουν πληροφορίες που μπορούν να ταυτοποιήσουν το
                            χρήστη, ωστόσο τα προσωπικά δεδομένα σας που διατηρούμε ενδέχεται να συνδέονται
                            με δεδομένα που αποθηκεύονται ή ανακτώνται από cookies. Χρησιμοποιούμε cookies
                            σύνδεσης και μόνιμα στον ιστότοπο μας.
                        </p>

                        <h4 className="font-semibold text-gray-900 mt-6">
                            1. Cookies που χρησιμοποιούμε και σκοπός χρήσης
                        </h4>

                        <ol className="list-decimal pl-6 mt-2 text-gray-700 leading-7 space-y-2">
                            <li>
                                Χρησιμοποιούμε στον ιστότοπο μας υπηρεσίες όπως{" "}
                                <span className="font-semibold">Google Analytics</span> και{" "}
                                <span className="font-semibold">Google Adwords</span> για:
                                <ul className="list-disc pl-6 mt-2 space-y-1">
                                    <li>αναγνώριση υπολογιστή κατά την επίσκεψη στον ιστότοπο</li>
                                    <li>ανάλυση της πλοήγησης και της χρήσης του ιστότοπου</li>
                                    <li>ενεργοποίηση και διαχείριση καλαθιού αγορών</li>
                                    <li>βελτίωση της λειτουργικότητας και ασφάλειας του ιστοτόπου</li>
                                    <li>προστασία από απάτη</li>
                                    <li>προσωποποίηση της εμπειρίας χρήστη</li>
                                </ul>
                            </li>
                        </ol>

                        <h4 className="font-semibold text-gray-900 mt-6">
                            2. Απόρριψη cookies μέσω περιηγητή
                        </h4>

                        <p className="text-gray-700 leading-7 mt-2">
                            Οι περισσότεροι περιηγητές σας επιτρέπουν να απορρίψετε τα cookies. Για παράδειγμα:
                        </p>

                        <ol className="list-decimal pl-6 mt-2 text-gray-700 leading-7 space-y-2">
                            <li>
                                <span className="font-semibold">Internet Explorer (version 10):</span> μέσω των ρυθμίσεων
                                “Εργαλεία”, “Επιλογές Internet”, “Απόρρητο” και “Για Προχωρημένους”.
                            </li>
                            <li>
                                <span className="font-semibold">Firefox (version 24):</span> “Εργαλεία”, “Επιλογές”,
                                “Απόρρητο”, επιλογή “Χρήση προσαρμοσμένων ρυθμίσεων για το ιστορικό” και
                                απενεργοποίηση της επιλογής “Αποδοχή cookies από ιστοτόπους”.
                            </li>
                            <li>
                                <span className="font-semibold">Chrome (version 29):</span> “Ρυθμίσεις”, “Προβολή
                                σύνθετων ρυθμίσεων”, “Ρυθμίσεις περιεχομένου” και επιλογή “Αποκλεισμός
                                ιστοτόπων από δεδομένα” στην ενότητα “Cookies”.
                            </li>
                        </ol>

                        <p className="text-gray-700 leading-7 mt-3">
                            Ο αποκλεισμός όλων των cookies ενδέχεται να επηρεάσει αρνητικά τη λειτουργικότητα
                            πολλών ιστοτόπων. Αν αποκλείσετε τα cookies, δεν θα μπορείτε να χρησιμοποιήσετε
                            όλες τις λειτουργίες του ιστοτόπου.
                        </p>

                        <h4 className="font-semibold text-gray-900 mt-6">
                            3. Διαγραφή cookies
                        </h4>

                        <p className="text-gray-700 leading-7 mt-2">
                            Μπορείτε επίσης να διαγράψετε cookies που έχουν ήδη αποθηκευτεί στον υπολογιστή
                            σας. Για παράδειγμα:
                        </p>

                        <ol className="list-decimal pl-6 mt-2 text-gray-700 leading-7 space-y-2">
                            <li>
                                <span className="font-semibold">Internet Explorer (version 10):</span> χειροκίνητη
                                διαγραφή αρχείων cookie (οδηγίες διαθέσιμες στη Microsoft).
                            </li>
                            <li>
                                <span className="font-semibold">Firefox (version 24):</span> “Εργαλεία”, “Επιλογές”,
                                “Απόρρητο”, “Προβολή Cookies” και “Αφαίρεση Όλων των Cookies”.
                            </li>
                            <li>
                                <span className="font-semibold">Chrome (version 29):</span> “Ρυθμίσεις”, “Εκκαθάριση
                                δεδομένων περιήγησης” και επιλογή “Διαγραφή cookies και άλλων δεδομένων
                                ιστοτόπου”.
                            </li>
                        </ol>

                        <p className="text-gray-700 leading-7 mt-3">
                            Η διαγραφή όλων των cookies μπορεί επίσης να επηρεάσει αρνητικά τη λειτουργικότητα
                            πολλών ιστοτόπων.
                        </p>


                        {/* ν). Δίκαιο */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">ν). Εφαρμοστέο Δίκαιο</h3>

                        <p className="text-gray-700 leading-7 mt-2">
                            Οποιαδήποτε διαφωνία προκύψει από τη λειτουργία του ηλεκτρονικού καταστήματος
                            ή τις συναπτόμενες συμβάσεις, διέπεται από το Ελληνικό Δίκαιο, με αποκλειστικά
                            αρμόδια τα ελληνικά δικαστήρια για την επίλυσή τους.
                        </p>

                        {/* ξ). Δήλωση αποποίησης */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">ξ). Δήλωση αποποίησης ευθύνης</h3>

                        <p className="text-gray-700 leading-7 mt-2">
                            Η εταιρεία μας δεν ευθύνεται για παράνομη χρήση πιστωτικής κάρτας από μη κάτοχο,
                            εφόσον δεν έχει δηλωθεί στην τράπεζα η απώλεια της, καθώς συνιστά ευθύνη του
                            πελάτη η φύλαξη της πιστωτικής του κάρτας.
                            Η εταιρεία μας καταβάλλει κάθε δυνατή προσπάθεια για την καλή λειτουργία του
                            ηλέκτρονικού καταστήματος χωρίς όμως να εγγυάται ότι οι λειτουργίες του ή των server
                            του θα είναι αδιάκοπες χωρίς κανενός είδους σφάλματος.
                        </p>

                        {/* ο). Αποδοχή όρων */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">ο). Αποδοχή όρων</h3>

                        <p className="text-gray-700 leading-7 mt-2">
                            Ο πελάτης δηλώνει ότι αποδέχεται ρητά και ανεπιφύλακτα τους παραπάνω όρους
                            συνεργασίας και αποδέχεται να πραγματοποιήσει την αγορά σύμφωνα με αυτούς.
                            Οι όροι χρήσης για τη συναλλαγή μεταξύ του πελάτη και του ηλεκτρονικού
                            καταστήματος έχουν διαβαστεί από τους ενδιαφερόμενους της συναλλαγής.
                        </p>

                        {/* π). Πνευματική ιδιοκτησία */}
                        <h3 className="text-lg font-semibold text-gray-900 mt-10">π). Πνευματική Ιδιοκτησία</h3>

                        <p className="text-gray-700 leading-7 mt-2">
                            Το υλικό που θα βρείτε στο ηλεκτρονικό μας κατάστημα ( Φωτογραφίες, σχόλια, κείμενο,
                            logo επιχείρησης κτλ.) είναι ιδιοκτησία της εταιρείας μας και προφυλάσσονται έναντι
                            όλων σύμφωνα με τις ισχύουσες νομοθετικές διατάξεις περί πνευματικής ιδιοκτησίας.
                        </p>

                    </div>
                </div>
            </section>

        </div>
    );
}

export default Terms;